import {Component} from "preact";
import HelpDeskMenu from "../help-desk-menu";
import ManualList from "../manual-list";

export default class HelpDeskMain extends Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 'main',
            params: {}
        };
    }

    render(props, state, context) {
        const pages = {
            main: () => <HelpDeskMenu onNavigate={this.navigate}/>,
            manuals: () => <ManualList onNavigate={this.navigate}/>
        };

        return pages[this.state.page]();
    }

    navigate = (page, params = {}) => {
        this.setState({
            page: page,
            params: params || {}
        });
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/help-desk/help-desk-main/index.js